module.exports = __webpack_public_path__ + "04_mole.0ad6a7bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer2/04_mole.png
// module id = JrrX
// module chunks = 0